export default {"src":"/_next/static/media/search-not-found.9c36e7de.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};